import type { ReactNode } from 'react'
import {
  useModuleNotificationCount,
  useRightPanel,
} from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/rightPanelContext'

interface UseModuleHeadingParams {
  moduleKey: string
  label?: string
  children: ReactNode
}

const useModuleHeading = ({ moduleKey, label, children }: UseModuleHeadingParams) => {
  const { expanded, openModule } = useRightPanel()
  const count = useModuleNotificationCount(moduleKey)
  const title = label ?? (typeof children === 'string' ? children : undefined)

  return {
    rail: !expanded,
    count,
    railLabel: count > 0 && title ? `${title} (${count})` : title,
    onOpen: () => openModule(moduleKey),
  }
}

export default useModuleHeading
